import React from 'react';
import { motion } from 'framer-motion';
import { supplies } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

export default function Supplies() {
  return (
    <div className="space-y-6">
      <header className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-800 tracking-tight">Cargo Inventory</h1>
          <p className="text-slate-500 mt-1 font-medium">Monitor supply levels across all sectors.</p>
        </div>
        <button className="w-full md:w-auto bg-[#0047AB] hover:bg-blue-800 text-white px-8 py-3.5 rounded-2xl font-black transition-all flex items-center justify-center gap-3 shadow-xl shadow-blue-900/20 uppercase text-xs tracking-widest hover:scale-[1.02] active:scale-[0.98]">
          <SafeIcon icon="FiPlus" className="text-lg" />
          <span>Add Cargo</span>
        </button>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {supplies.map((item, index) => (
          <motion.div 
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            className="bg-white/80 backdrop-blur-xl rounded-[2.5rem] p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)] border border-white relative overflow-hidden group flex flex-col h-full"
          >
            {/* Aesthetic Glow */}
            <div 
              className="absolute top-0 right-0 w-48 h-48 rounded-full blur-[80px] opacity-[0.08] transition-opacity group-hover:opacity-15 pointer-events-none -translate-y-1/2 translate-x-1/2" 
              style={{ backgroundColor: item.color }} 
            />
            
            <div className="flex justify-between items-start mb-8 relative z-10">
              <div>
                <span className="text-[10px] font-black tracking-[0.2em] uppercase text-slate-400 mb-1.5 block">
                  {item.category} Sector
                </span>
                <h3 className="text-xl font-black text-slate-800 tracking-tight">{item.name}</h3>
              </div>
              <button className="w-10 h-10 rounded-2xl bg-slate-50 flex items-center justify-center text-slate-400 hover:text-[#0047AB] hover:bg-white hover:shadow-md transition-all">
                <SafeIcon icon="FiMoreVertical" />
              </button>
            </div>

            <div className="mb-8 relative z-10 flex-1 flex flex-col justify-end">
              <div className="flex justify-between items-end mb-3">
                <span className="text-4xl font-black tracking-tighter" style={{ color: item.color }}>
                  {item.remaining}
                  <span className="text-base text-slate-300 font-black ml-1 uppercase tracking-widest">{item.unit}</span>
                </span>
                <span className={`text-[10px] font-black px-3 py-1.5 rounded-xl uppercase tracking-widest border ${
                  item.status === 'critical' ? 'bg-red-50 text-red-600 border-red-100' : 
                  item.status === 'low' ? 'bg-orange-50 text-orange-600 border-orange-100' : 
                  'bg-green-50 text-green-600 border-green-100'
                }`}>
                  {item.status} Status
                </span>
              </div>
              
              {/* Progress Bar with Tech Styling */}
              <div className="h-4 w-full bg-slate-100 rounded-full overflow-hidden p-1 border border-white/50 shadow-inner relative">
                <motion.div 
                  initial={{ width: 0 }}
                  animate={{ width: `${item.remaining}%` }}
                  transition={{ duration: 1.2, ease: "circOut" }}
                  className="h-full rounded-full relative"
                  style={{ backgroundColor: item.color }}
                >
                  <div className="absolute inset-0 bg-white/20 animate-pulse" />
                </motion.div>
              </div>
            </div>

            <div className="pt-6 border-t border-slate-50 flex gap-3 relative z-10">
              <button className="flex-1 py-3 bg-white border border-slate-100 rounded-2xl text-[10px] font-black uppercase tracking-widest text-slate-500 hover:bg-slate-50 hover:text-[#0047AB] transition-all shadow-sm">
                Update
              </button>
              <button className="flex-1 py-3 bg-[#F5EFE6] text-[#0047AB] rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-[#0047AB] hover:text-white transition-all shadow-sm">
                Restock
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="text-center pt-12 opacity-40">
        <div className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">
          Made by LingLink AI and DigLab AI
        </div>
      </div>
    </div>
  );
}